import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CorporatePromoPage } from './corporate-promo.page';

const routes: Routes = [
  {
    path: '',
    component: CorporatePromoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CorporatePromoPageRoutingModule {}
